import { TemplateRef } from '@angular/core';
import { ModalOptions, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

/** Modal options plus the `nzComponentParams` that NG-ZORRO 16 removed. */
export type ModalWithParams<T> = ModalOptions<T> & { nzComponentParams?: Partial<T> };

/**
 * Opens an NG-ZORRO modal and sets `nzComponentParams` on its content component, as NG-ZORRO 15
 * did: `create()` builds the component synchronously, so the values are in place before its first
 * change detection and its `ngOnInit` reads them as before. NG-ZORRO 16 only offers `nzData`
 * through `NZ_MODAL_DATA`, which every component would have to read (feature 024, hop 16).
 *
 * When the content is a template, NG-ZORRO 15 gave it `nzComponentParams` as its `$implicit`
 * context; NG-ZORRO 16 gives it `nzData`, so the params travel there instead.
 */
export function openModal<T>(modal: NzModalService, options: ModalWithParams<T>): NzModalRef<T> {
  const { nzComponentParams } = options;
  const toTemplate = nzComponentParams && options.nzContent instanceof TemplateRef;
  const modalRef = modal.create<T>(toTemplate ? { ...options, nzData: nzComponentParams } : options);
  if (nzComponentParams && !toTemplate && modalRef.componentInstance) {
    Object.assign(modalRef.componentInstance, nzComponentParams);
  }
  return modalRef;
}
